import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-111">
    <div className="glass-panel rounded-3xl p-8 md:p-12 text-center border-brand-gold/40 relative overflow-hidden pt-[20px] pb-[20px] pl-[15px] pr-[15px]" data-id="element-112">
      <div className="absolute top-0 left-0 w-full h-full bg-brand-gold/5 pointer-events-none" data-id="element-113"></div>
      <Shield className="w-16 h-16 text-brand-gold mx-auto mb-6" data-id="element-114" />
      <h2 className="text-3xl font-serif font-bold mb-4" data-id="element-115">
        GARANTÍA 7 DÍAS — SIN PREGUNTAS
      </h2>
      <p className="text-lg text-brand-text/90 mb-6 leading-relaxed" data-id="element-116">
        Abrís los tomos. Hacés las prácticas. Si en 7 días no es lo que
        esperabas: devolución del 100% sin formularios, sin drama.
      </p>
      <div className="inline-block bg-brand-surfaceLight px-4 py-2 rounded-full text-sm text-brand-text/80 border border-brand-text/10" data-id="element-117">
        Tasa de devoluciones: menos del 1%.
      </div>
    </div>
  </Section>;
export const Footer = () => <footer className="border-t border-brand-text/10 pt-16 pb-8 px-4 sm:px-6 lg:px-8 text-center mt-12 space-x-[8px] bg-[#132B1A] space-y-[10px]" data-id="element-118">
    <div className="max-w-4xl mx-auto space-x-[8px] space-y-[1px]" data-id="element-119">
      <div className="inline-flex items-center space-x-2 mb-6" data-id="element-120">
        <span className="text-2xl" data-id="element-121">✦</span>
        <span className="font-serif font-bold tracking-wider text-brand-gold text-xl" data-id="element-122">
          LUMEN AKASHA™
        </span>
      </div>

      <p className="text-brand-text/80 max-w-2xl mx-auto mb-8 text-[14px]" data-id="element-123">
        El sistema de transformación financiera N°1 para personas con estrés
        económico en Argentina.
        <br data-id="element-124" />
        <br data-id="element-125" />
        Porque prosperar en Argentina no es imposible. Es un sistema. Y ese
        sistema ahora es tuyo.
      </p>

      <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8 text-sm text-brand-text/60 mb-12 pt-[10px] pb-[10px] mt-[1px] ml-[8px] items-center justify-center" data-id="element-126">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-gold transition-colors" data-id="element-127">
          📧 soportelumenakasha@gmail.com
        </a>
        <span className="hidden md:inline" data-id="element-128">•</span>
        <a href="https://www.instagram.com/lumen.akasha" className="hover:text-brand-gold transition-colors" data-id="element-129">
          📲 @lumen.akasha
        </a>
        <span className="hidden md:inline" data-id="element-130">•</span>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-gold transition-colors" data-id="element-131">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-brand-text/40 mb-12 pt-[10px] pb-[10px]" data-id="element-132">
        © Lumen Akasha™ 2025 — Todos los derechos reservados. Prohibida la
        reproducción y redistribución sin autorización expresa.
      </div>

      <p className="text-xl md:text-2xl font-serif italic text-brand-gold/80" data-id="element-133">
        "La abundancia no llegó un día. Llegó un instante a la vez."
      </p>
      <p className="text-brand-text/60 mt-4 font-medium" data-id="element-134">✦ Lumen Akasha ✦</p>
    </div>
  </footer>;